import React from 'react';
import PropTypes from 'prop-types';

function DataList({data}) {
    return (
        <table className='datalist'>
            <tbody className='datalist__body'>
            {data.map((dataEntry, i) => (
                <tr className='datalist__entry' key={i}>
                    <th className='datalist__key'>{dataEntry.key}</th>
                    <td className='datalist__value'>{dataEntry.value}</td>
                </tr>
            ))}
            </tbody>
        </table>
    );
}

DataList.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.any,
        value: PropTypes.any
    })).isRequired,
};

export default DataList;
